import { render, staticRenderFns } from "./AkcijskiKatalog.vue?vue&type=template&id=1e5463e6"
import script from "./AkcijskiKatalog.vue?vue&type=script&lang=js"
export * from "./AkcijskiKatalog.vue?vue&type=script&lang=js"
import style0 from "./AkcijskiKatalog.vue?vue&type=style&index=0&id=1e5463e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports